module.exports = __webpack_public_path__ + "static/media/header.b5b1c902.png";